"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelatedContentProperty = exports.relatedContentPropertyDefinition = void 0;
exports.relatedContentPropertyDefinition = {
    view: {
        label: 'Related content',
        style: '',
    },
    constraints: [],
    type: 'asset',
    multiple: true,
    name: 'related-content',
};
const isRelatedContentProperty = (prop) => {
    return prop.name === exports.relatedContentPropertyDefinition.name;
};
exports.isRelatedContentProperty = isRelatedContentProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVsYXRlZC1jb250ZW50LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVsYXRlZC1jb250ZW50LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixLQUFLLEVBQUUsRUFBRTtLQUNWO0lBQ0QsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGlCQUFpQjtDQUNRLENBQUE7QUFJMUIsTUFBTSx3QkFBd0IsR0FBRyxDQUFDLElBQWtCLEVBQWtDLEVBQUU7SUFDN0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHdDQUFnQyxDQUFDLElBQUksQ0FBQTtBQUM1RCxDQUFDLENBQUE7QUFGWSxRQUFBLHdCQUF3Qiw0QkFFcEMifQ==